import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import '../layout/RedefinirSenha.Modulo.css'
import logob from '../images/logos/logo-d-azul.png'
import logoBranco from '../images/logos/Logo com Avatar br.png'
import poster from '../images/logos/aplique parede_rgb_1.jpg'
import i18n from './i18n'
import { useTranslation } from 'react-i18next';
function RedefinirSenha() {
    const { t, i18n } = useTranslation('');

    const { token } = useParams();
    console.log("Token recebido na URL:", token);
    const [newPassword, setNewPassword] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post('https://advancelighting.pt/redefinir_senha.php', {
                token: token,
                new_password: newPassword,
            },
            {
                headers: { 'Content-Type': 'application/json' },
            }
        );
            setMessage(t('redefinirsenha.success_message'));
        } catch (error) {
            console.error('Erro ao redefinir senha:', error);
            setMessage(t('redefinirsenha.error'));
            console.log("Token enviado:", token);
        }
    };

    useEffect(() => {
        // Adiciona uma classe ao body quando o componente for montado
        document.body.classList.add('backgroundImage');

        // Limpa a classe quando o componente for desmontado
        return () => {
            document.body.classList.remove('backgroundImage');
        };
    }, []);  // O array vazio [] garante que isso ocorra apenas uma vez

  return (
    <div className='container RedefinirSenha'>
        <div className="mainDiv">
            <div className="cardStyle">
            <form action method="post" name="signupForm" id="signupForm" onSubmit={handleSubmit}>
                <img src={logob} id="signupLogo" />
                <h4 className="formTitle mt-4">{t('redefinirsenha.title')}</h4>
                <div className="inputDiv">
                <label className="inputLabel mt-3" htmlFor="password">{t('redefinirsenha.new_psw')}</label>
                <input type="password" placeholder="Nova senha" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
                </div>
                <div className="buttonWrapper">
                <button type="submit" id="submitButton" onclick="validateSignupForm()" className="submitButton pure-button pure-button-primary">
                    <span>{t('redefinirsenha.title2')}</span>
                </button>
                {message && <p className='text-center mt-1'>{message}</p>}
                </div>
            </form>
            </div>
        </div>    
    </div>
  )
}

export default RedefinirSenha